import React from 'react'
import Terms from '../../Componet/Terms'
import NewsletterL1 from '../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader'
import Aca1 from '../../Componet/Academy/Aca1'


function TermsConditions() {
    return (
        <>
            <HerosectionHeader folder1={"pages"} folder2={"Utilities"} name={"Academy"} />
            <div class="page-content">
                <Aca1></Aca1>
                <NewsletterL1 />
            </div>
        </>
    )
}

export default TermsConditions
